import * as React from "react"
import { Splide, SplideTrack, SplideSlide } from "@splidejs/react-splide"
import "@splidejs/react-splide/css"
import { GatsbyImage } from "gatsby-plugin-image"
import { Link } from "gatsby"

const HomeCategories = props => {
  return (
    <section className={"mb-20"}>
      <div className={"max-w-7xl mx-auto px-6"}>
        <div className={"text-center mb-8"}>
          <h2 className={"text-3xl text-navy font-bold mb-4"}>
            Our range of Ifor Williams trailers
          </h2>
          <p className={"text-grey-700 text-lg"}>
            We stock a wide range of brand new Ifor Williams trailers.
          </p>
        </div>

        <Splide
          hasTrack={false}
          aria-label=""
          className={"w-full px-10"}
          options={{
            type: "loop",
            perPage: 5,
            pagination: false,
            gap: "0.5rem",
            breakpoints: {
              1024: { perPage: 3 },
              768: { perPage: 2 },
              640: { perPage: 1 },
            },
          }}
        >
          <SplideTrack>
            {props.nodes &&
              props.nodes.map(node => (
                <SplideSlide>
                  <Link
                    to={"trailers/" + node.slug.current}
                    className={"group relative h-0 pb-44"}
                  >
                    {node.image != null && (
                      <GatsbyImage
                        alt={node.title}
                        image={node.image.asset.gatsbyImageData}
                        className={"object-contain"}
                      />
                    )}
                    <h2 className={"text-navy font-bold text-center"}>
                      {node.title}
                    </h2>
                  </Link>
                </SplideSlide>
              ))}
          </SplideTrack>

          <div className="splide__arrows">
            <button className="splide__arrow--prev absolute flex items-center justify-center cursor-pointer bg-grey-100 text-navy-500 h-full w-10 top-0 !left-0 pransition duration-300 ease-in-out hover:bg-navy-500 hover:text-white">
              <svg
                className="w-8 h-8 !transform-none"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M10 19l-7-7m0 0l7-7m-7 7h18"
                ></path>
              </svg>
            </button>
            <button className="splide__arrow--next absolute flex items-center justify-center cursor-pointer bg-grey-100 text-navy-500 h-full w-10 top-0 !right-0 transition duration-300 ease-in-out hover:bg-navy-500 hover:text-white">
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  stroke-width="2"
                  d="M14 5l7 7m0 0l-7 7m7-7H3"
                ></path>
              </svg>
            </button>
          </div>
        </Splide>
      </div>
    </section>
  )
}

export default HomeCategories
